import OutletWrapper from '@/components/animations/animated-routes/animated-outlet';
import { Col } from '@/components/grid/grid-component';
import TabSelector from '@/components/page-tabs/page-tab-selector-component';
import Pill from '@/components/pill/pill-component';
import { Heading3Text } from '@/utils/global-fonts';
import { toSentenceCase } from '@/utils/utils';
import { useMemo } from 'react';
import { useParams, useRouteLoaderData } from 'react-router-dom';
import Styled from './company-management-style';

/**
 * Company Management page component.
 * @returns {JSX.Element} The rendered Company Management page component.
 */
const CompanyManagement = () => {
  const { id } = useParams();
  const { data } = useRouteLoaderData('companies-crud');

  const tabData = useMemo(
    () => [
      {
        label: 'Details',
        path: `/app/company-management/view/${id}`,
        permissions: ['company.read'],
        type: '*',
      },
      {
        label: 'Pricing',
        path: `/app/company-management/view/${id}/pricing`,
        permissions: ['price.read'],
        type: 'supplier',
      },
      {
        label: 'Options',
        path: `/app/company-management/view/${id}/options`,
        permissions: ['option.read'],
        type: 'supplier',
      },
      {
        label: 'Product Category',
        path: `/app/company-management/view/${id}/product-category`,
        permissions: ['productCategory.read'],
        type: 'supplier',
      },
      {
        label: 'Templates',
        path: `/app/company-management/view/${id}/templates`,
        permissions: ['template.read'],
        type: 'supplier',
      },
      {
        label: 'Products',
        path: `/app/company-management/view/${id}/products`,
        permissions: ['product.read'],
        type: 'supplier',
      },
      {
        label: 'Quote Modules',
        path: `/app/company-management/view/${id}/quote-module`,
        permissions: ['quoteModule.read'],
        type: 'dealer',
      },
    ],
    [id],
  );

  return (
    <Styled.TabHolder>
      <Col xs={12}>
        <Styled.StyleRow>
          <Heading3Text>{toSentenceCase(data?.company?.name)}</Heading3Text>
          {data?.company?.is_dealer && <Pill type="Dealer" />}
          {data?.company?.is_supplier && <Pill type="Supplier" />}
        </Styled.StyleRow>
        <TabSelector
          tabs={tabData}
          typeCheck={(type) => {
            if (type === 'supplier') {
              return data?.company?.is_supplier;
            }
            if (type === 'dealer') {
              return data?.company?.is_dealer;
            }
            return true;
          }}
        />
        <OutletWrapper slide={25} slideUp={0} initial={false} />
      </Col>
    </Styled.TabHolder>
  );
};

export default CompanyManagement;
